module.exports = __webpack_public_path__ + "img/Medicago_truncatula.f00cd08f.jpg";